/** Present legacy store rich text consistently without changing catalogue content. */
class RichText extends HTMLElement {
  connectedCallback() {
    const normalize = value => value.toLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
    const title = normalize(this.dataset.title || '');
    const heading = this.querySelector('h1,h2,h3,h4,h5,h6');
    if (title && heading && normalize(heading.textContent) === title) heading.remove();
    for (const element of this.querySelectorAll('p,h1,h2,h3,h4,h5,h6,.spacer30,.contactboxes,.row > .col-xs-12')) {
      if (!element.textContent.trim() && !element.querySelector('img,iframe,video,svg,input,button')) element.remove();
    }
    for (const link of this.querySelectorAll('a[href^="mailto:"]')) {
      const email = link.textContent.trim();
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) link.setAttribute('href', `mailto:${email}`);
    }
    for (const element of this.querySelectorAll('h1,h2,h3,h4,h5,h6')) {
      const prose = element.textContent.trim().length > 160 || element.closest('li');
      if (!prose && element.tagName !== 'H1') continue;
      const replacement = document.createElement(prose ? 'p' : 'h2');
      for (const attribute of element.attributes) replacement.setAttribute(attribute.name, attribute.value);
      replacement.append(...element.childNodes);
      element.replaceWith(replacement);
    }
  }
}
if (!customElements.get('ac-rich-text')) customElements.define('ac-rich-text', RichText);
